import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M12.84,18.32a3,3,0,0,1-4.45.24L4.87,15a3.1,3.1,0,0,1-.23-4.24A3,3,0,0,1,9,10.68l1.08,1.08a.25.25,0,0,0,.37,0l4.44-5.51a.25.25,0,0,0-.07-.37A9.67,9.67,0,0,0,8.54,4.51,9.75,9.75,0,1,0,19.37,15.86a9.89,9.89,0,0,0-.32-4.62.26.26,0,0,0-.44-.08Z",
        fill: "#86bd4d"
      }),
      _createElementVNode("path", {
        d: "M23.44.39a1.5,1.5,0,0,0-2.11.23L10.39,14.2,7.93,11.74a1.51,1.51,0,0,0-2.12,0,1.49,1.49,0,0,0,0,2.12L9.45,17.5a1.51,1.51,0,0,0,2.22-.12l12-14.88A1.51,1.51,0,0,0,23.44.39Z",
        fill: "#86bd4d"
      })
    ], -1)
  ])))
}
export default { render: render }